function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// angular will not be defined if we're testing.
if (typeof angular !== 'undefined') {
  angular.module('service.paymentOptionService', []).service('PaymentOptionService', PaymentOptionService);
}

function PaymentOptionService() {
  var that = this,
      _initialised = false,
      _paymentState = {},
      _appointmentsInWorkshop;

  that.init = function (paymentOptions, appointmentsToPayFor) {
    var appointmentsInWorkshop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    _appointmentsInWorkshop = appointmentsInWorkshop; // Need to know how many appointments in workshop
    // for workshop costs.

    _paymentState = {
      singleAppointments: 0,
      workshopAppointments: 0,
      workshopsPaidFor: 0,
      totalAppointments: 0,
      creditAppointments: 0,
      packageAppointments: 0,
      appointmentsPaidFor: 0,
      appointmentsToPayFor: 0,
      totalCost: 0,
      formattedCost: ''
    };
    if (typeof appointmentsToPayFor === 'undefined') throw new Error('Bad initialisation');
    _paymentState.paymentOptions = paymentOptions;
    _paymentState.appointmentsPaidFor = 0;
    _paymentState.appointmentsToPayFor = appointmentsToPayFor;
    _paymentState.totalAppointments = appointmentsToPayFor; // If the customer has existing credit, then use as much as that as possible to pay for appointments.
    // NB: for workshops if there is a package for the workshop and the customer has credit then it probably
    // makes sense to use the credit.

    if (_paymentState.paymentOptions.customerpackages && _paymentState.paymentOptions.customerpackages.length) {
      var customerPackages = _paymentState.paymentOptions.customerpackages; // Customer packages need to be ordered by:
      // - expiry date ascending (if set)
      // - credits left

      for (var i = 0; i < customerPackages.length; i++) {
        customerPackages[i].appointmentsPaidFor = customerPackages[i].appointmentsPaidFor || 0;

        while (_paymentState.appointmentsToPayFor > 0 && customerPackages[i].credits > 0) {
          _paymentState.appointmentsToPayFor--;
          _paymentState.appointmentsPaidFor++;
          customerPackages[i].appointmentsPaidFor += 1;
          customerPackages[i].credits--;
        }
      }
    }

    if (_paymentState.paymentOptions.packages && _paymentState.paymentOptions.packages.length) {
      for (var j = 0; j < _paymentState.paymentOptions.packages.length; j++) {
        _paymentState.paymentOptions.packages[j]['appointmentsPaidFor'] = 0;
        _paymentState.paymentOptions.packages[j]['packagesPurchased'] = 0;
      }
    }

    that.verifyPaymentState();
    _initialised = true;
    return _paymentState;
  };

  that.verifyPaymentState = function () {
    // Get the number of appointments paid for with each customer package and each payment package.
    var creditAppointments = 0,
        packageAppointments = 0,
        totalCost = 0;
    totalCost += _paymentState.singleAppointments * _paymentState.paymentOptions.singleappointmentcost;
    totalCost += _paymentState.workshopsPaidFor * _paymentState.paymentOptions.workshopcost;

    _paymentState.paymentOptions.customerpackages.forEach(function (creditPackage) {
      creditAppointments += creditPackage.appointmentsPaidFor;
    });

    _paymentState.paymentOptions.packages.forEach(function (paymentPackage) {
      packageAppointments += paymentPackage.appointmentsPaidFor;

      if (paymentPackage.purchased) {
        totalCost += paymentPackage.cost * paymentPackage.purchased;
      }
    });

    if (_paymentState.singleAppointments + _paymentState.workshopAppointments + creditAppointments + packageAppointments !== _paymentState.appointmentsPaidFor) {
      throw new Error('Payment state invalid');
    }

    if (_paymentState.singleAppointments + _paymentState.workshopAppointments + creditAppointments + packageAppointments + _paymentState.appointmentsToPayFor !== _paymentState.totalAppointments) {
      throw new Error('Payment state invalid');
    }

    if (_paymentState.singleAppointments < 0 || creditAppointments < 0 || packageAppointments < 0) {
      throw new Error('Payment state invalid');
    } // Thought this function was supposed to be validating not calculating but anyway.


    _paymentState.totalCost = totalCost; // TODO: Do formatted cost.
  }; // Customer is adding or removing a single appointment as payment method


  that.updateSingleAppointment = function (add) {
    if (!_initialised) throw new Error('Service uninitialised');

    if (typeof add === 'undefined') {
      add = true;
    } // It's possible that single appointment cost could be zero


    if (typeof _paymentState.paymentOptions.singleappointmentcost === 'undefined') {
      throw new Error('Single appointment payment option is not available');
    } // Not paying for more appointments if there are none left to pay for


    if (add && _paymentState.appointmentsToPayFor <= 0) {
      return _paymentState;
    }

    if (add) {
      _paymentState.singleAppointments++;
      _paymentState.appointmentsToPayFor--;
      _paymentState.appointmentsPaidFor++;
      _paymentState.totalCost += _paymentState.paymentOptions.singleappointmentcost;
    } else if (_paymentState.singleAppointments >= 1) {
      _paymentState.singleAppointments = _paymentState.singleAppointments - 1;
      _paymentState.appointmentsToPayFor++;
      _paymentState.appointmentsPaidFor--;
      _paymentState.totalCost -= _paymentState.paymentOptions.singleappointmentcost;
    } else {
      return _paymentState;
    }

    that.verifyPaymentState();
    return _paymentState;
  }; // Remove all single appointments


  that.removeSingleAppointments = function () {
    if (!_initialised) throw new Error('Service uninitialised'); // It's possible that single appointment cost could be zero

    if (typeof _paymentState.paymentOptions.singleappointmentcost === 'undefined') {
      throw new Error('Single appointment payment option is not available');
    }

    var singleAppointments = _paymentState.singleAppointments;
    _paymentState.singleAppointments = 0;
    _paymentState.appointmentsToPayFor += singleAppointments;
    _paymentState.appointmentsPaidFor -= singleAppointments;
    _paymentState.totalCost -= _paymentState.paymentOptions.singleappointmentcost * singleAppointments;
    that.verifyPaymentState();
    return _paymentState;
  }; // Add or subtract appointments that are paid for with customer credit.


  that.updateCustomerCredit = function (packageID, numAppts, add) {
    that.removeSingleAppointments();
    add = typeof add === 'undefined' ? true : add;
    numAppts = parseInt(numAppts);
    var customerPackages = _paymentState.paymentOptions.customerpackages,
        customerPackage = null;

    for (var i = 0; i < customerPackages.length; i++) {
      if (customerPackages[i]._id === packageID) {
        customerPackage = customerPackages[i];
        break;
      }
    }

    if (!customerPackage) {
      throw new Error('Customer package not found');
    } // ** Adding appointments **, ** subtracting credit **


    if (add) {
      if (customerPackage.credits < numAppts) {
        return _paymentState;
      }

      customerPackage.appointmentsPaidFor = customerPackage.appointmentsPaidFor ? customerPackage.appointmentsPaidFor + numAppts : numAppts;
      customerPackage.credits -= numAppts;
      _paymentState.appointmentsToPayFor -= numAppts;
      _paymentState.appointmentsPaidFor += numAppts;
      _paymentState.packageAppointments += numAppts;
    } else {
      // ** Subtracting appointments, adding credit **
      if (customerPackage.appointmentsPaidFor < numAppts) {
        return _paymentState;
      }

      customerPackage.appointmentsPaidFor -= numAppts;
      customerPackage.credits += numAppts;
      _paymentState.appointmentsToPayFor += numAppts;
      _paymentState.appointmentsPaidFor -= numAppts;
    }

    that.verifyPaymentState();
    return _paymentState;
  }; // Either add or subtract a package. Customer can only add / subtract one at a time.


  that.updatePackage = function (packageID, add) {
    add = typeof add === 'undefined' ? true : add;
    that.removeSingleAppointments();
    var packages = _paymentState.paymentOptions.packages,
        newPackage = packages.find(function (testPackage) {
      return testPackage._id === packageID;
    });

    if (!newPackage) {
      throw new Error('Package not found');
    }

    if (add) {
      // Customer is purchasing a package
      // Don't allow the customer to add the package if the uses are limited.
      if (newPackage.packageuses && newPackage.purchased >= newPackage.packageuses) throw new Error('Package uses exceeded');
      var newAppts = newPackage.numappts;
      newPackage.purchased = newPackage.purchased ? newPackage.purchased + 1 : 1;
      newPackage.appointmentsPaidFor = newPackage.appointmentsPaidFor || 0; // Pay for any outstanding appointments with credits from this package.

      if (_paymentState.appointmentsToPayFor) {
        var toPayFor = _paymentState.appointmentsToPayFor; // There are more new appointments than appointments to pay for.

        if (toPayFor <= newAppts) {
          newPackage.appointmentsPaidFor += toPayFor;
          _paymentState.appointmentsPaidFor += toPayFor;
          _paymentState.appointmentsToPayFor = 0;
        } else {
          // There are fewer new appointments than appointments to pay for.
          newPackage.appointmentsPaidFor += newAppts;
          _paymentState.appointmentsToPayFor -= newAppts;
          _paymentState.appointmentsPaidFor += newAppts;
        }
      }
    } else {
      // Customer is returning a package from their selection
      // Make sure that this package is already in the selection
      var paymentPackage = null;

      for (var j = 0; j < _paymentState.paymentOptions.packages.length; j++) {
        if (_paymentState.paymentOptions.packages[j]._id === packageID && _paymentState.paymentOptions.packages[j].purchased) {
          paymentPackage = _paymentState.paymentOptions.packages[j];
          break;
        }
      }

      if (!paymentPackage) throw new Error('Payment package not found'); // Got the package, now update the totals

      var totalCredits = paymentPackage.purchased * newPackage.numappts,
          remainingCredits = totalCredits - newPackage.numappts;

      if (remainingCredits < paymentPackage.appointmentsPaidFor) {
        var difference = paymentPackage.appointmentsPaidFor - remainingCredits;
        paymentPackage.appointmentsPaidFor -= difference;
        _paymentState.appointmentsToPayFor += difference;
        _paymentState.appointmentsPaidFor -= difference;
      }

      paymentPackage.purchased--;
    }

    that.verifyPaymentState();
    return _paymentState;
  }; // Reset appointments that have been paid for with customer credit


  that.removeCustomerCredits = function () {
    var removedAppointments = 0;
    _paymentState.paymentOptions.customerpackages = _paymentState.paymentOptions.customerpackages.map(function (customerPackage) {
      removedAppointments += customerPackage.appointmentsPaidFor;
      return _objectSpread({}, customerPackage, {
        appointmentsPaidFor: 0
      });
    });
    _paymentState.appointmentsPaidFor -= removedAppointments;
    _paymentState.appointmentsToPayFor += removedAppointments;
    that.verifyPaymentState();
    return _paymentState;
  }; // The customer is adding or removing a workshop charge.
  // If they are adding a workshop then all appointments are paid for and appointments to pay for drops to zero.
  // If they're subtracting a workshop then reset everything to allow the other options.
  // !!! The customer may need to pay for more than one workshop - i.e. if they are booking for more than one person.


  that.updateWorkshop = function () {
    var addWorkshop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!_appointmentsInWorkshop) throw new Error('Workshops incorrectly initialised'); // No point in allowing single / credit appointments if the customer is paying for the whole workshop.
    // Remove all existing payment options.

    that.removeSingleAppointments();
    that.removeCustomerCredits();
    addWorkshop ? _paymentState.workshopsPaidFor++ : _paymentState.workshopsPaidFor--;
    addWorkshop ? _paymentState.appointmentsToPayFor -= _appointmentsInWorkshop : _paymentState.appointmentsToPayFor += _appointmentsInWorkshop;
    addWorkshop ? _paymentState.appointmentsPaidFor += _appointmentsInWorkshop : _paymentState.appointmentsPaidFor -= _appointmentsInWorkshop;
    addWorkshop ? _paymentState.totalCost += _paymentState.paymentOptions.workshopcost : _paymentState.totalCost += _paymentState.paymentOptions.workshopcost;
    addWorkshop ? _paymentState.workshopAppointments += _appointmentsInWorkshop : _paymentState.workshopAppointments -= _appointmentsInWorkshop;
    that.verifyPaymentState();
    return _paymentState;
  }; // A coupon has been added and validated. Attach it to the package so it can be verified again
  // when payment is made.


  that.addCoupon = function (packageID, coupon) {
    var packages = _paymentState.paymentOptions.packages;

    for (var i = 0; i < packages.length; i++) {
      if (packages[i]._id === packageID) {
        packages[i].couponvalid = true;
        packages[i].couponcode = coupon;
        break;
      }
    }

    that.verifyPaymentState();
    return _paymentState;
  };

  that.getPaymentState = function () {
    if (!_initialised) {
      throw new Error('service unitialised');
    }

    return _paymentState;
  }; // Determine if all appointments can be paid for with a membership


  that.payByMembership = function (serviceID, paymentOptions) {
    if (!paymentOptions.customerMemberships || !paymentOptions.customerMemberships.length) {
      return false;
    }

    var memberships = paymentOptions.customerMemberships;
    var validMemberships = memberships.filter(function (membership) {
      return membership.services.find(function (service) {
        return service === serviceID;
      });
    }); // There may be more than one membership that applies, just return the first in the list.

    return validMemberships[0];
  };
}

module.exports = PaymentOptionService;